import styled from "@emotion/styled";

export const QuestionParagraph = styled.p`
  margin-top: 0;
  white-space: pre-line;
`;

export default QuestionParagraph;
